var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"home-box-button",attrs:{"to":_vm.to}},[_vm._v(" Read More ")])
}
var staticRenderFns = []

export { render, staticRenderFns }